var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "Layer_35",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m54.99,19.38h-9.98v-3.08c0-.55.45-1,1-1h7.98c.55,0,1,.45,1,1v3.08Z",
        },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m65.6,56.32v31.44c0,1.1-.89,2-2,2h-27.2c-1.11,0-2-.9-2-2v-31c0-6.93,4.37-13.05,10.61-15.21v-14.71h9.98v14.69c6.17,2.08,10.61,7.92,10.61,14.79Z",
        },
      }),
      _c("rect", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          x: "43.05",
          y: "19.38",
          width: "13.9",
          height: "7.46",
          rx: "1",
          ry: "1",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }